

import React, { useState, useEffect, useRef } from 'react';

const CounterCard = ({ value, title, Icon, duration }) => {
  const [count, setCount] = useState(0);
  const countRef = useRef(null);

  const end = parseInt(value, 10) || 0;
  const animDuration = parseInt(duration, 10) || 2000;

  useEffect(() => {
    const fetchData = async () => {
      let url = '';
      switch (title.toLowerCase()) {
        case 'ejob users':
          url = `${process.env.REACT_APP_API_URL}jobseeker/allJobSeeker`;
          break;
        case 'companies':
          url = `${process.env.REACT_APP_API_URL}jobrecruiter/allJobEmployer`;
          break;
        case 'applications':
          url = `${process.env.REACT_APP_API_URL}application/allApplication`;
          break;
        case 'jobs':
          url = `${process.env.REACT_APP_API_URL}job/alljob2`;
          break;
        default:
          break;
      }

      if (url) {
        try {
          const response = await fetch(url);
          const data = await response.json();
          setCount(data.length || 0);
        } catch (error) {
          console.log(error)
          console.error(`Error fetching ${title} data:`, error);
        }
      }
    };

    fetchData();
  }, [title]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          let start = 0;
          const increment = end / (animDuration / 16);

          const timer = setInterval(() => {
            start += increment;
            setCount(Math.floor(start));

            if (start >= end) {
              clearInterval(timer);
              setCount(end);
            }
          }, 16);

          return () => clearInterval(timer);
        }
      },
      { threshold: 0.1 } 
    );

    if (countRef.current) {
      observer.observe(countRef.current);
    }

    return () => {
      if (countRef.current) {
        observer.unobserve(countRef.current);
      }
    };
  }, [end, animDuration]);

  return (
    <div
      ref={countRef}
      className="bg-orange-100 px-12 w-16 sm:px-16 sm:w-56 h-12 sm:h-auto transition-all duration-500 py-8 hover:bg-orange-600 hover:scale-105 hover:text-white text-orange-500 flex items-center justify-center flex-col m-0"
    >
      {Icon}
      <span className="text-1xl block font-semibold">{count}</span>
      <span className="text-sm block font-semibold">{title}</span>
    </div>
  );
};

export default CounterCard;